/**
 * Browser file downloads. The DOM half of CSV export; `csv.ts` holds the pure
 * serialization.
 */

/**
 * Hand the user a file.
 *
 * Throws if the browser refuses, which callers rely on: the SpringVerify export
 * only marks applicants as sent once the file is actually on disk.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  // Firefox ignores a click on an anchor that is not in the document.
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  // Revoking synchronously races the download in some browsers, which silently
  // produces an empty file.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/**
 * Download a CSV string.
 *
 * The BOM is what makes Excel on Windows read the file as UTF-8; without it,
 * any non-ASCII name arrives as mojibake.
 */
export function downloadCsvFile(csv: string, filename: string): void {
  const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, filename);
}
